import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import DialogActions from '@material-ui/core/DialogActions';
import PlatformChanger from '../Common/PlatformChanger';
import LocalizedStrings from '../Localization/localization';

class PlatformChangerModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
        };
    }

    onPlatformIdChanged = () => {
        this.closeModal();
    }

    handleModalToggle = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
        if (this.props.toggleUserSettings) {
            this.props.toggleUserSettings();
        }
    }

    closeModal = () => {
        if (this.props.toggleUserSettings) {
            this.props.toggleUserSettings(false);
        }
        this.setState({ isModalOpen: false });
    }


    render() {
        return (
            <div style={this.props.fullWidth === true ? { width: '100%' } : { display: 'inline-block' }}>
                <Dialog
                    fullWidth
                    maxWidth='md'
                    fullScreen={this.props.fullScreen}
                    open={this.state.isModalOpen}
                    onClose={this.closeModal}
                >
                    <DialogContent>
                        <h3>{LocalizedStrings.changePlatform}</h3>
                        <PlatformChanger
                            onPlatformIdChanged={this.onPlatformIdChanged}
                        />
                    </DialogContent>
                    <DialogActions>
                        {this.props.fullScreen &&
                            <Button onClick={this.closeModal} color="primary">
                                {LocalizedStrings.done}
                            </Button>
                        }
                    </DialogActions>
                </Dialog>
                <div style={this.props.fullWidth === true ? { width: '100%', lineHeight: this.props.iconPlaceholderHeight ? this.props.iconPlaceholderHeight : undefined } : { display: 'inline-block' }} onClick={this.handleModalToggle}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

PlatformChangerModal.propTypes = {
    fullWidth: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    fullScreen: PropTypes.bool.isRequired,
    toggleUserSettings: PropTypes.func,
    iconPlaceholderHeight:PropTypes.string,
};

export default withMobileDialog()(withRouter(PlatformChangerModal));